import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

export default ({ blockProperties, onUpdateBlockProperties, onSave }) => {
    return (
        <>
            <FormGroup>
                <ControlLabel>Код встраивания виджета</ControlLabel>
                <FormControl
                    value={blockProperties.embedCode}
                    componentClass="textarea"
                    rows={12}
                    maxLength={1024}
                    onChange={({target}) => onUpdateBlockProperties({embedCode: target.value})}
                    onBlur={({target}) => onSave({embedCode: target.value})}
                />
            </FormGroup>
        </>
    )
};
